@if (startSpinner) {
  <div>
    <span
      class="fa fa-spinner fa-pulse fa-2x fa-fw fa-align-center"
      aria-hidden="true"
    ></span>
    'Loading... Please wait'
  </div>
}
